import { A, Br, Button, Div, not, H2, P, UL, LI, Span, reactive } from 'alkali'
import { get, post, patch, put} from '../../tools/request'
import { track } from 'components/tracking/track'
import { faqOrReadOnly, showLiveAnalysis } from 'model/SearchQuery'
import app from '../../app/app'
import './Explanation.scss'
import Icon from 'components/Icon'
import * as settingsIcon from 'icons/cog.svg'
import { completeWorkflowMap, searchResultsTextIndex, screeningTextIndex, extractTextIndex } from './WorkflowTour'
import { hasScreeningAccess } from 'model/Screening'
import { activeTab } from 'model/StudyCollection'
import { studyDetailsPane } from '../studies/StudyDetailsPane'
import { hasExtractAccess, switchToScreeningTab, switchToExtractTab } from '../studies/StudiesTabs'
import { currentTab, handleAccordion, openAccordion } from 'pages/Entry'
import { shortcutsTab } from './AvailableQuestionsPane'

let buildQuestion = document.querySelector('.ask-question')
let blanket = new Div('.blanket', {})

class Explanation extends Div('.welcome-explanation') {
	created(properties) {
		properties.content = [...properties.content]
		properties.display = true
	}
}

/*
* Welcome Page: Accessed from drop down menu on home page
*	- Opening Dialog
*		-> ExampleQuestions
*		-> FilterExplanation -> ResultsPageOverview
*/

export const OpeningDialog = Explanation.with(
	'.initial-explanation',
	{
		attached() {
			document.addEventListener('keydown', function (e) {
				if (e.keyCode == 27) {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					return
				}
			})
			buildQuestion.classList.add('welcome-styling')
			buildQuestion.append(blanket)
		},
	},
	[
		Div('.top-container', [
			Div('.header', [
				H2('Welcome to DocAnalytics!'),
				A('.close', [' '], {
					onclick() {
						quitAutoPromptTourNoUser('dashboardStatisticsTour')
						quitAutoPromptTour('DashboardStatistics')
						buildQuestion.classList.remove('welcome-styling')
						removeContents()
						return
					},
				}),
			]),
			Div('.explanatory-text', {
				display: not(faqOrReadOnly),
			}, [
				Div(['This platform is designed to answer safety and efficacy questions for therapies. DocAnalytics will quantify and analyze data involving a patient condition, therapeutic interventions, and an outcome.', Br, Br,
				'Start by building your research question using the PICO builder or by clicking on one of the example questions'
				]),
			]),
		]),
		Div('.bottom-container', [
			Button('.cancel.primary', ['Build a Question'], {
				onclick(event) {
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					// navigate to FilterExplanation
					tourRunner(welcomePageMap, 1)
					event.stopPropagation()
					event.preventDefault()
					return
				},
				ready() {
					faqOrReadOnly.valueOf() ? (this.hidden = true) : null
				},
				attached() {
					!document.querySelector('.dashboard-statistics')
						? this.classList.remove('hidden')
						: this.classList.add('hidden')
				},
			}),
			Button('.cancel.primary', ['Example Questions'], {
				onclick(event) {
					if (currentTab !== 'examples') {
						document.querySelector('#examples').classList.add('add-glow-animation-to-button')
					}
					showExamples()
					setTimeout(() => {
						if (!document.querySelector('#examples').className.includes('current-tab'))
							document
								.querySelector('#examples')
								.classList.remove('add-glow-animation-to-button')
					}, 2000)
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					// navigate to ExampleQuestions
					tourRunner(welcomePageMap, 2)
					event.stopPropagation()
					event.preventDefault()
					return
				},
			}),
		], {
			ready() {
				faqOrReadOnly.valueOf()
					&& (this.classList =
							'bottom-container flex-end')
			},
		}),
	]
)

const showExamples = () =>{
	shortcutsTab.put('examples')
	let headerElement = document.getElementById('shortcuts-header'),
		accordionOpen = headerElement?.classList?.contains("active"),
		sectionContent = headerElement?.nextElementSibling
	if(!accordionOpen){
		openAccordion(headerElement, sectionContent)
	}
}

export const FilterExplanation = Explanation.with('.characteristics-explanation', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('dashboardStatisticsTour')
				quitAutoPromptTour('DashboardStatistics')
				buildQuestion.className = 'ask-question'
				removeContents()
				document.querySelectorAll('.filter-search').forEach(item => {item.className = 'filter-search'})
				return
			}
		})
		buildQuestion.append(blanket)
		buildQuestion.classList.add('characteristics')
		let explanatoryText = document.querySelector('.explanatory-text')
		explanatoryText.innerHTML = ''
		explanatoryText.append(
			P(['Enter your PICO (patient condition, intervention/comparator treatments, outcome) of interest. Each PICO element needs to be entered and selected individually.', Br]),
			P(['Example:', Br, 
				'P = moderate to severe atopic dermatitis', Br,
				'I/C= abrocitinib, upadacitinib, baricitinib', Br,
				'O = EASI-75', Br,
			]),
			P(['As you fill out the PICO form, DocAnalytics will update the suggestions with relevant terms based on your selections.'])
		)
	}
}, 
[
	Div('.top-container', [
		Div('.header', [H2('Build a Question'), 
			A('.close', [' '], {
				onclick() {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					buildQuestion.className = 'ask-question'
					removeContents()
					document.querySelectorAll('.filter-search').forEach(item => {item.className = 'filter-search'})
					return
				}
			}),
		]),
		Div('.explanatory-text', ['']),
	]),
	Div('.bottom-container', [
		Button('.back.secondary', ['Back'], {
			onclick() {
				buildQuestion.classList.replace('characteristics-step-two', 'characteristics')
				let explanatoryText = document.querySelector('.explanatory-text')
				explanatoryText.innerHTML = ''
				explanatoryText.append(
					P(['Enter your PICO (patient condition, intervention/comparator treatments, outcome) of interest. Each PICO element needs to be entered and selected individually.', Br]),
					P(['Example:', Br, 
						'P = moderate to severe atopic dermatitis', Br,
						'I/C= abrocitinib, upadacitinib, baricitinib', Br,
						'O = EASI-75', Br,
					]),
					P(['As you fill out the PICO form, DocAnalytics will update the suggestions with relevant terms based on your selections.'])
				)
			}
		}),
		Button('.back2.primary', ['Back to welcome dialog'], {
			onclick(event) {
				buildQuestion.className = 'ask-question'
				removeContents()
				// navigate back to OpeningDialog
				tourRunner(welcomePageMap, 0)
				event.stopPropagation()
				event.preventDefault()
			}
		}),
		Button('.learn.primary', ['Next'], {
			onclick() {
				buildQuestion.classList.replace('characteristics', 'characteristics-step-two')
				document.querySelector('.explanatory-text').innerHTML = ''
				document.querySelector('.explanatory-text').append(
					P('To continue the tour, select one of the research questions below:'), Br,
					A({ // Example queries, navigate to ResultsPageOverview
						href: `${window.location.href}?search=How_does_(intervention:SUQb8v:Upadacitinib)%2C_(intervention:SUTm1N:Abrocitinib)_or_(intervention:Baricitinib)_affect_(outcome:SGIsS,easi%2050:EASI-50)_for_patients_with_(condition:Moderate_to_severe_Atopic_Dermatitis)_vs_control%3F&selections=VoEesjuJA&tour=true#view=sources&study=undefined`
					}, ['How does Upadacitinib, Abrocitinib or Baricitinib affect EASI-50 for patients with Moderate to severe Atopic Dermatitis vs control?']), Br,
					A({
						href: `${window.location.href}?search=Does_(intervention:Humira)_improve_(outcome:Clinical_Remission)_in_patients_with_(condition:Crohns_Disease)%3F&selections=wrlFNPvbc&tour=true`
					}, ['Does Humira improve Clinical Remission in patients with Crohns Disease?']), Br,
					A({
						href: `${window.location.href}?search=Does_(intervention:Nifedipine)_or_(intervention:Enalapril)_improve_(outcome:Systolic_Blood_Pressure)%3F&selections=VbQlFVQFd&tour=true#direct`
					}, ['Does Nifedipine or Enalapril improve Systolic Blood Pressure?'])
				)
				return
			}
		}),
	]),
])

export const ExampleQuestions = Explanation.with(
	'.filter-explanation',
	{
		attached() {
			document.addEventListener('keydown', function (e) {
				if (e.keyCode === 27) {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					if (document.querySelector('.ask-question'))
						buildQuestion.classList.remove('dashboard-statistics-filter-pane-explanation')
					removeContents()
					return
				}
			})
			buildQuestion.append(blanket)
			buildQuestion.classList.add('dashboard-statistics-filter-pane-explanation')
		},
	},
	[
		Div('.top-container', [
			Div('.header', [
				H2('Example Questions'),
				A('.close', [' '], {
					onclick() {
						quitAutoPromptTourNoUser('dashboardStatisticsTour')
						quitAutoPromptTour('DashboardStatistics')
						buildQuestion.classList.remove('dashboard-statistics-filter-pane-explanation')
						removeContents()
						return
					},
				}),
			]),
			Div(
				'.explanatory-text',
				{
					ready() {
						if (!document.querySelector('#examples').className.includes('active')) {
							this.append(
								P([`Example questions are available to help you get acquainted with DocAnalytics. After using DocAnalytics, you'll also find your recent and favorited questions here. `]),
								P(['Click the Examples tab and select one of the questions to continue the tour.']),
							)
						} else {
							this.append(
								P([`Example questions are available to help you get acquainted with DocAnalytics. After using DocAnalytics, you'll also find your recent and favorited questions here. `]),
							)
						}
					},
				},
			),
		]),
		Div('.bottom-container.flex-end', [
			Button('.back2.primary', ['Back to welcome dialog'], {
				onclick(event) {
					buildQuestion.classList.remove('dashboard-statistics-filter-pane-explanation')
					removeContents()
					// navigate back to OpeningDialog
					tourRunner(welcomePageMap, 0)
					event.stopPropagation()
					event.preventDefault()
				},
			}),
		]),
	]
)

export const welcomePageMap = [
	{
        target: '.ask-question',
        element: OpeningDialog
    },
	{
        target: '.accessible-accordion',
        element: FilterExplanation
    },
	{
        target: '.available-questions-pane',
        element: ExampleQuestions
    },
]

/*
* Results Page: Accessed from FilterExplanation hyperlinks or from drop down help menu
*	- ResultsPageOrientation 
		-> (Quick Analysis Tour) ResultsQuickAnalysis -> AnalyzableQuickAnalysis -> RunQuickAnalysis
		-> (Complete Workflow Tour) SearchResults -> Screening -> Extract -> AnalyzableQuickAnalysis -> RunQuickAnalysis
*/

export let tourSection = reactive('')
// Navigates either to Quick Analysis Tour or to Complete Workflow tour
const ResultsPageOrientation = Explanation.with('.quick-analysis', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('metaReportTour')
				quitAutoPromptTour('MetaReport')
				removeContents()
				document.querySelector('.search-results').classList.remove('report-styling')
				return
			}
		})
		if (showLiveAnalysis) showLiveAnalysis.put(false)
	}
}, [
	Div('.top-container', [
		Div('.header', [
			H2('Search Results Orientation'),
			A('.close', [' '], {
				onclick() {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					return
				},
			}),
		]),
		Div('.explanatory-text', [
			P("This is the results page. Here you'll be able to:"),
			UL([
				LI('Review studies and available data'),
				LI('Update or adjust your question'),
				LI('Screen study results'),
				LI('Extract additional study data'),
				LI('Preview your analysis results'),
				LI('Run an analysis'), Br,
			]),
			P('Click on Complete Workflow to learn more about each step or skip ahead to review available analyzable data by clicking quick Analysis.')
		])
	]),
	Div('.bottom-container', [
		Button('.cancel.primary', ['Quick Analysis'], {
			onclick(event) {
				buildQuestion.classList.remove('welcome-styling')
				tourSection.put('QuickAnalysis')
				removeContents()
				// Navigate to ResultsQuickAnalysis
				tourRunner(quickAnalysisMap, 1)
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
		Button('.cancel.primary', ['Complete Workflow'], {
			onclick(event) {
				buildQuestion.classList.remove('welcome-styling')
				tourSection.put('CompleteWorkflow')
				removeContents()
				// Navigate to CompleteWorkflowOrientation
				tourRunner(completeWorkflowMap, 0)
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
	]),  
])

const resultsText = [
	[P("The Search Results tab shows all of the studies DocAnalytics has found from searching the universe of literature and trials based on your search terms. DocAnalytics searches across:"), Br,
	UL([
		LI('PubMed/Medline'),
		LI('Trials Registries (clinicaltrials.gov, EU Trials, WHO ICTRP)'),
		LI('DocCongress, a selection of congress abstracts'),
		LI('CORD 19, a COVID-19 literature database'),
		LI('MedRxiv')
	]),
	P('Some of these studies have data that is pre-configured and available for analysis. Studies without pre-configured data can be reviewed and manually entered, if desired.'), 
	P('DocAnalytics pre-configured data comes from:'), Br,
	UL([
		LI('Trials Registries, any posted study results (Clinicaltrials.gov, EU Trials)'),
		LI("DrEvidence's database of curated and quality controlled data from ~30,000 studies")
	])],

	[P('To select and review studies with available, pre-curated data click the checkbox at the top of the study list.'), P('To open but not select studies, click the ➤ to review studies prior to selecting for analysis.'), Br,
	P({style: 'font-weight: bold'}, 'Click the checkbox to continue the tour.')],

	[P('Use the filter panel to adjust the conditions, treatments, and outcomes included. Additionally, study filters can specify study design, source, publication date, or be used to find your own collections of studies.')],

	[P('Navigate to the Analyzable tab to review and make selections for the analyzable studies.')]
]

let resultsTextIndex = 0
const ResultsQuickAnalysis = Explanation.with('.quick-analysis-search', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('metaReportTour')
				quitAutoPromptTour('MetaReport')
				removeContents()
				document.querySelector('.search-results').classList.remove('report-styling')
				return
			}
		})
		document.querySelector('.quick-analysis-search .top-container').append(new Div('.explanatory-text', [renderText(resultsText, resultsTextIndex)]))
		if (showLiveAnalysis.valueOf()) 
			showLiveAnalysis.put(false)
		buildQuestion.append(blanket)
	}
}, [
	Div('.top-container', [
		Div('.header', [
			H2('Search Results'),
			A('.close', [' '], {
				onclick() {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					return
				},
			}),
		]),
	]),
	Div('.bottom-container', [
		Button('.back-button', ['Back'], {
			onclick(event) {
				document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))
				if (resultsTextIndex == 0) {
					removeContents()
					// Navigate to ResultsPageOverview
					tourRunner(quickAnalysisMap, 0)
				} else {
					resultsTextIndex--
					if (resultsTextIndex == 0) {
						if (!document.querySelector('.blanket'))
							buildQuestion.append(blanket)
					} else if (resultsTextIndex == 1) {
						// automatic study selection checkbox
						controlUX('.study-head-item.study-toggle', '.highlight-circle', 5000, 'append')	
						document.querySelectorAll('.blanket').forEach(item => {item.remove()})
						if (document.querySelector('.analyzable.dgrid-selected')) { // checkbox checked
							document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(resultsText, resultsTextIndex)]))
							let text = document.querySelector('.top-container .explanatory-text')
							text.removeChild(text.lastChild)
							return
						}
					} else if (resultsTextIndex == 2) {
						controlUX('.search-results .filter-pane', 'glow', 8000)
					}				
					document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(resultsText, resultsTextIndex)]))
				}
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
		Button('.next-button', ['Next'], {
			onclick(event) {
				document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))
				if (resultsTextIndex == 3) {
					activeTab.put('analyzable')
					studyDetailsPane.hide()
					removeContents()
					// Navigate to AnalyzableQuickAnalysis
					tourRunner(quickAnalysisMap, 2)
				} else {
					resultsTextIndex++
					if (resultsTextIndex == 1) {
						controlUX('.study-head-item.study-toggle', '.highlight-circle', 5000, 'append')	
						document.querySelectorAll('.blanket').forEach(item => {item.remove()})
						if (document.querySelector('.analyzable.dgrid-selected')) { // checkbox checked
							document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(resultsText, resultsTextIndex)]))
							let text = document.querySelector('.top-container .explanatory-text')
							text.removeChild(text.lastChild)
							return
						}
					} else if (resultsTextIndex == 2) {
						controlUX('.search-results .filter-pane', 'glow', 8000)
					} else if (resultsTextIndex == 3) {
						controlUX('#selected p', 'add-highlight', 8000)
						document.querySelector('#selected p').onclick = () => {
							if (this.onclick === null) return
							removeContents()
							// Navigate to AnalyzableQuickAnalysis
							tourRunner(quickAnalysisMap, 2)
							this.onclick = null
							return
						}
					}
					document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(resultsText, resultsTextIndex)]))
				}
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
	]),  
])

const analyzableText = [

	[P("The Analyzable tab contains all of your selected studies that have data available for analysis. Here you'll see each study's data and be able to make selections to customize what is included in your analysis."), Br, 
	P("At the top of the study list you'll find the evidence summary, a preview of the analysis based on your current selections. ")],

	[P("The evidence summary displays patient demographics and study characteristics of selected studies. Predictor variable analysis is available for age or gender in a direct analysis. "), Br,
	Span([P("Find more information on"), A(' predictor variable analysis ', {href: "https://confluence.doctorevidence.com/display/shareit/80117785/IAJf6d114115b5f4975b89a0797a946593aKII", target: "_blank"}), P("in the help content.")])],

	[P("Each study's summary provides information about the study size and design, outcome measured, groups, and data for the currently selected outcome. Many of these fields can be updated or customized based on your analysis preferences and needs. ")],

	[P("View the study ID (acronym, NCT number, or author name), the outcome, and the timepoint it was measured at."),
	P("Studies may have multiple relevant outcomes as well as multiple timepoints for each outcome. Click to open and select from the drop-down of available options. "),
	P("Additionally, multiple publications may be associated with this study population. Open the drop-down to view available publications and select the desired publication.")],

	[P("View the number of participants, group name, and the DocAnalytics auto-generated group assignment."), 
	P("The group assignment determines how the treatment group is considered in the analysis and can be updated or customized based on your analysis needs. ")],

	[P("The outcome data is displayed graphically for easy understanding and comparison between groups. The effect size is also displayed in the circle to the right of the data.")],

	[P("DocAnalytics offers many types of analysis, all with their own customizable settings. Open the dropdown to select the analysis type."), Br, Span([P("To open and review the settings, click the "), Icon('.settings-icon', { icon: settingsIcon })])],

	[P("Once studies have been reviewed and selections have been made, navigate to the View Analysis tab to see the final result!")]
]
let analyzableTextIndex = 0
const AnalyzableQuickAnalysis = Explanation.with('.quick-analysis-analyzable', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('metaReportTour')
				quitAutoPromptTour('MetaReport')
				removeContents()
				document.querySelector('.search-results').classList.remove('report-styling')
				return
			}
		})
		document.querySelector('.quick-analysis-analyzable .top-container').append(new Div('.explanatory-text', [renderText(analyzableText, analyzableTextIndex)]))
		if (!showLiveAnalysis.valueOf())
			showLiveAnalysis.put(true)
		if (!document.querySelector('.search-results .study-head').classList.contains('expanded')) {
			let page = document.querySelector('.search-results')
			page.querySelector('.study-list').expandAll(true)
		}
	}
}, [
	Div('.top-container', [
		Div('.header', [
			H2('Analyzable'),
			A('.close', [' '], {
				onclick() {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					return
				},
			}),
		]),
	]),
	Div('.bottom-container', [
		Button('.back-button', ['Back'], {
			async onclick(event) {
				document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))
				if (analyzableTextIndex == 0) {
					document.querySelector('#selected p').classList.remove('add-highlight')
					removeContents()
					if (tourSection.valueOf() === 'QuickAnalysis') {
						activeTab.put('sources')
						studyDetailsPane.hide()
						// Navigate to ResultsQuickAnalysis
						tourRunner(quickAnalysisMap, 1)
					} else {
						// Navigate to Extract/Screening/Search Results
						if (hasExtractAccess.valueOf()) {
							switchToExtractTab()
							tourRunner(completeWorkflowMap, 2)
						} else if (hasScreeningAccess.valueOf()) {
							switchToScreeningTab()
							tourRunner(completeWorkflowMap, 1)
						} else {
							activeTab.put('sources')
							studyDetailsPane.hide()
							tourRunner(completeWorkflowMap, 0)
						}
					}
					return
				} else {
					analyzableTextIndex--
					if (analyzableTextIndex == 2) {
						buildQuestion.append(blanket)
						controlUX('.dgrid-content .analyzable', 'glow', 15000, 'groupSingle')
					} else if (analyzableTextIndex == 3) {
						// study name, outcome, and timepoint
						controlUX('.dgrid-content .analyzable .study-name', "glow", 6000, 'groupSingle')
						controlUX('.dgrid-content .analyzable .study-outcome-name', "glow", 6000, 'groupSingle')
						controlUX('.dgrid-content .analyzable .study-timepoint', "glow", 6000, 'groupSingle')
					} else if (analyzableTextIndex == 4) {
						controlUX('.search-results .studies-container .study-group-N', '.group-highlight', 6000, 'append')
					} else if (analyzableTextIndex == 5) {
						// the data and effect size
						controlUX('.dgrid-content .analyzable', 'glow', 6000, 'group', '.dgrid-content .analyzable .group-selected')
						controlUX('.dgrid-content .analyzable .study-report-treatment-circle', 'glow', 6000, 'groupSingle')
					} else if (analyzableTextIndex == 6) {
						// analysis type dropdown
						document.querySelectorAll('.blanket').forEach(item => {item.remove()})
						document.querySelector('.search-results .next-button').classList.remove('hidden')
						controlUX('.search-results .analysis-type-selector', 'glow', 6000)
					}
					document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(analyzableText, analyzableTextIndex)]))
				}
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
		Button('.next-button', ['Next'], {
			onclick(event) {
				document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))
				analyzableTextIndex++

				if (analyzableTextIndex == 2) {
					buildQuestion.append(blanket)
					// first study
					controlUX('.dgrid-content .analyzable', 'glow', 15000, 'groupSingle')
				} else if (analyzableTextIndex == 3) {
					// study name, outcome, and timepoint
					controlUX('.dgrid-content .analyzable .study-name', "glow", 6000, 'groupSingle')
					controlUX('.dgrid-content .analyzable .study-outcome-name', "glow", 6000, 'groupSingle')
					controlUX('.dgrid-content .analyzable .study-timepoint', "glow", 6000, 'groupSingle')
				} else if (analyzableTextIndex == 4) {
					// group population, assignment, name
					controlUX('.search-results .studies-container .study-group-N', '.group-highlight', 4000, 'append')
				} else if (analyzableTextIndex == 5) {
					// the data and effect size
					controlUX('.dgrid-content .analyzable', 'glow', 6000, 'group', '.dgrid-content .analyzable .group-selected')
					controlUX('.dgrid-content .analyzable .study-report-treatment-circle', 'glow', 6000, 'groupSingle')
				} else if (analyzableTextIndex == 6) {
					// analysis type dropdown
					document.querySelectorAll('.blanket').forEach(item => {item.remove()})
					controlUX('.search-results .analysis-type-selector', 'add-highlight', 6000)
				} else if (analyzableTextIndex == 7) {
					document.querySelector('.quick-analysis-analyzable .next-button').classList.add('hidden')
				}

				document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(analyzableText, analyzableTextIndex)]))
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
	]),  
])

const summaryText = [
	[P(Span([P("Your analysis is summarized in a forest plot and an easy to understand evidence statement. Find information on how to read a forest plot"), A(' here.', {href: "https://confluence.doctorevidence.com/display/shareit/87097456/FJE5628bb74b0244a13b981f64f0f5e6694SZX", target: "_blank"})]))],

	[P("Click to download a detailed meta-analysis report with additional data visualization, normalized study data, and citations.")]
]

let summaryTextIndex = 0
const RunQuickAnalysis = Explanation.with('.quick-analysis-view-analysis', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('metaReportTour')
				quitAutoPromptTour('MetaReport')
				removeContents()
				document.querySelector('.search-results').classList.remove('report-styling')
				return
			}
		})
		document.querySelector('.quick-analysis-view-analysis .top-container').append(new Div('.explanatory-text', [renderText(summaryText, summaryTextIndex)]))
		document.querySelector('.search-results .back-button').classList.add('hidden')
		setTimeout(() => {
			controlUX('.search-results .evidence-statement', 'glow', 6000)
		}, 2000)
	}
}, [
	Div('.top-container', [
		Div('.header', [
			H2('Analysis Summary'),
			A('.close', [' '], {
				onclick() {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					return
				},
			}),
		]),
	]),
	Div('.bottom-container', [
		Button('.back-button', ['Back'], {
			onclick(event) {
				document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))
				summaryTextIndex--

				if (summaryTextIndex == 0) {
					controlUX('.search-results .evidence-statement', 'add-highlight', 2000)
					document.querySelector('.quick-analysis-view-analysis .next-button').classList.remove('hidden')
					document.querySelector('.search-results .back-button').classList.add('hidden')
					document.querySelector('.quick-analysis-view-analysis .bottom-container').removeChild(document.querySelector('.exit-tour'))
				}
				
				document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(summaryText, summaryTextIndex)]))
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
		Button('.next-button', ['Next'], {
			onclick(event) {
				document.querySelector('.top-container').removeChild(document.querySelector('.explanatory-text'))
				summaryTextIndex++

				if (summaryTextIndex == 1) {
					controlUX('.search-results .meta-analysis', 'add-highlight', 2000)
					document.querySelector('.quick-analysis-view-analysis .back-button').classList.remove('hidden')
					document.querySelector('.quick-analysis-view-analysis .next-button').classList.add('hidden')
					document.querySelector('.quick-analysis-view-analysis .bottom-container').append(new Button('.exit-tour', {
						onclick: () => {
							quitAutoPromptTourNoUser('dashboardStatisticsTour')
							quitAutoPromptTour('DashboardStatistics')
							buildQuestion.classList.remove('welcome-styling')
							removeContents()
							return
						}
					}, 'Close Tour'))
				}

				document.querySelector('.top-container').append(new Div('.explanatory-text', [renderText(summaryText, summaryTextIndex)]))
				event.stopPropagation()
				event.preventDefault()
				return
			},
		}),
	]),  
])

export const quickAnalysisMap = [
    {
        target: '.search-results',
        element: ResultsPageOrientation
    },
    {
        target: '.search-results',
        element: ResultsQuickAnalysis
    },
    {
        target: '.search-results',
        element: AnalyzableQuickAnalysis
    },
	{
		target: '.search-results',
		element: RunQuickAnalysis
	}
]

/*
	Auxiliary Functions
*/

export function tourRunner(section, itemIndex) {
	document.querySelector(section[itemIndex].target).append(section[itemIndex].element)
}

export function renderText(text, index) {
	return [...text[index]]
}

export function textReset() {
	resultsTextIndex = 0
	analyzableTextIndex = 0
	summaryTextIndex = 0

	searchResultsTextIndex.put(0)
	screeningTextIndex.put(0)
	extractTextIndex.put(0)
}

export function controlUX(selector, effect, duration = 0, type = 'single', additional?) {
	if (type === 'single') {
		document.querySelector(selector).classList.add(effect)
		setTimeout(() => {
			document.querySelector(selector).classList.remove(effect)
		}, duration)
	} else if (type === 'groupSingle') {
		document.querySelectorAll(selector)[0].classList.add(effect)
		setTimeout(() => {
			document.querySelectorAll(selector)[0].classList.remove(effect)
		}, duration)
	} else if (type === 'each') {
		document.querySelectorAll(selector).forEach(node => node.classList.add(effect))
		setTimeout(() => {
			document.querySelectorAll(selector).forEach(node => node.classList.remove(effect))
		}, duration)
	} else if (type === 'group') {
		// accepts 'additional' argument to select elements to be removed
		document.querySelectorAll(selector)[0].querySelectorAll(additional).forEach(node => node.classList.add(effect))
		setTimeout(() => {
			document.querySelectorAll(selector)[0].querySelectorAll(additional).forEach(node => node.classList.remove(effect))
		}, duration)
	} else if (type === 'append') {
		document.querySelector(selector).append(new Div(effect, []))
		setTimeout(() => {
			document.querySelector(selector).removeChild(document.querySelector(effect))
		}, duration)
	}
}			

export function quitAutoPromptTourNoUser(page) {
	localStorage.setItem(page, 'hide')
}

// Tour will not initally appear if user selects exit
export async function quitAutoPromptTour(page) {
	let user = await app.user
	let history = user?.Settings?.Tour || {DashboardStatistics: false, Articles: false, MetaReport: false, Extract: false, QuestionEditing: false}
	if (!history[page] && user) {
		history[page] = true
		patch<User>('/portal/User/'+app.user.Id, {
			data: {
				Settings: {
					Tour: history 
				}
			}
		})
	}
}

// remove components from screen
export function removeContents() {
	document.querySelectorAll('.welcome-explanation').forEach(item => {item.remove()})
	document.querySelectorAll('.blanket').forEach(item => {item.remove()})
}

